var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38481 19C8.82243 20.5856 10.2752 21.75 12 21.75H16C18.0711 21.75 19.75 20.0711 19.75 18V10C19.75 8.27523 18.5856 6.82243 17 6.38481V14C17 16.7614 14.7614 19 12 19H8.38481Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.25C5.92893 2.25 4.25 3.92893 4.25 6V14C4.25 16.0711 5.92893 17.75 8 17.75H12C14.0711 17.75 15.75 16.0711 15.75 14V6C15.75 3.92893 14.0711 2.25 12 2.25H8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.b447cf23b002410c92e9453fca029c3b.svg";
export { ForwardRef as ReactComponent };